// @flow

import styled from "@emotion/styled";

export const SortMenu = styled.span`
  position: relative;
  display: inline-block;
`;
